module.exports = __webpack_public_path__ + "images/emoji/person_with_pouting_face.40d8faf584f66dec99f1.png";